import { useCustomNavigation } from "@app/components/navigation/NavigationHandler"
import { useGetFunnel } from "@app/store/service/connectorService"
import { Image } from "@tecreation/funnel-components"
import { useEffect } from "react"

export function TabletImmersiveRoomBase({ children }) {
	const { push } = useCustomNavigation()
	const { data } = useGetFunnel()
	useEffect(() => {
		let timer = setTimeout(
			() => {
				push("/tablet-sauna-boat-1")
			},
			5 * 1000 * 60 * 60,
		)
		return () => clearTimeout(timer)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<div className="h-100 w-100 flex">
			<Image
				asBackground
				src="img/4701eafb-1bb0-470a-a3a4-5fb98e3593ad.jpeg"
				style={{ height: "100%", width: "30%", backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center center" }}
			/>
			<div className="flex-1 ml-8 mt-8 flex flex-column">
				<div className="f1 color-fg-secondary">{data?.funnel}</div>
				<div className="rounded-3 border flex-1 m-6 ml-0 boxShadow px-4 py-5 flex flex-column">{children}</div>
			</div>
		</div>
	)
}
